// extracted by mini-css-extract-plugin
module.exports = {"header":"DetailScreen_header__22pXY","avatar":"DetailScreen_avatar__186Li","avatarContainer":"DetailScreen_avatarContainer__36UEb"};